export var PROCESSING_VERIFY_EMAIL = 'PROCESSING_VERIFY_EMAIL';
export var FINISHED_VERIFY_EMAIL = 'FINISHED_VERIFY_EMAIL';
export var processingVerifyEmail = {
  type: PROCESSING_VERIFY_EMAIL
};
export var finishedVerifyEmail = function finishedVerifyEmail(payload) {
  return {
    type: FINISHED_VERIFY_EMAIL,
    payload: payload
  };
};
export var fetchConfirmEmail = function fetchConfirmEmail(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      userid = payload.userid,
      d1 = payload.d1;
    dispatch(processingVerifyEmail);
    var fetchUrl = atob(d1);
    var fetchPayload = {
      VerifyEmailCode: verifycode,
      UserId: Number(userid)
    };
    fetch(fetchUrl + 'confirmemail', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      response.json().then(function (res) {
        if (res.result) {
          return dispatch(finishedVerifyEmail({
            error: false,
            message: 'Your email has been verified successfully. You can now login to the exchange.'
          }));
        }
        return dispatch(finishedVerifyEmail({
          error: true,
          message: res.errormsg
        }));
      }).catch(function (e) {
        console.error(e);
        return dispatch(finishedVerifyEmail({
          error: true,
          message: 'Your email verification has failed. Follow the instructions after clicking the button below. Contact the exchange admin if the problem persists.'
        }));
      });
    });
  };
};